
export const NEW_FILTER_USUARIO_PRODUTOR = 'NEW_FILTER_USUARIO_PRODUTOR';
export const NEW_FILTER_USUARIO_PRODUTOR_PENDING = 'NEW_FILTER_USUARIO_PRODUTOR_PENDING';
export const NEW_FILTER_USUARIO_PRODUTOR_SUCCESS = 'NEW_FILTER_USUARIO_PRODUTOR_SUCCESS';
export const NEW_FILTER_USUARIO_PRODUTOR_FAILURE = 'NEW_FILTER_USUARIO_PRODUTOR_FAILURE';

export const NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR = 'NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR';
export const NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_PENDING = 'NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_PENDING';
export const NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_SUCCESS = 'NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_SUCCESS';
export const NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_FAILURE = 'NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_FAILURE';

export const LIST_USUARIO_PRODUTOR = 'LIST_USUARIO_PRODUTOR';
export const LIST_USUARIO_PRODUTOR_PENDING = 'LIST_USUARIO_PRODUTOR_PENDING';
export const LIST_USUARIO_PRODUTOR_SUCCESS = 'LIST_USUARIO_PRODUTOR_SUCCESS';
export const LIST_USUARIO_PRODUTOR_FAILURE = 'LIST_USUARIO_PRODUTOR_FAILURE';

export const FIND_USUARIO_PRODUTOR_DETAILS = 'FIND_USUARIO_PRODUTOR_DETAILS';
export const FIND_USUARIO_PRODUTOR_DETAILS_PENDING = 'FIND_USUARIO_PRODUTOR_DETAILS_PENDING';
export const FIND_USUARIO_PRODUTOR_DETAILS_SUCCESS = 'FIND_USUARIO_PRODUTOR_DETAILS_SUCCESS';
export const FIND_USUARIO_PRODUTOR_DETAILS_FAILURE = 'FIND_USUARIO_PRODUTOR_DETAILS_FAILURE';
